export const VOTE_METHOD_FETCH_REQUEST = 'VOTE_METHOD_FETCH_REQUEST';
export const VOTE_METHOD_FETCH = 'VOTE_METHOD_FETCH';
